import {
	Id,
	MarriageClaimExport,
	MarriageClaimSchema,
	MarriageSearchResultsSchema,
	MarriageSignatureVerificationSchema,
	TaxYearBracketSchema,
	type MarriageClaim,
	type MarriageSearchResults,
	type SendableMarriageExportSearchOptions,
	type SendableMarriageSearchOptions,
	type TaxYearBracket,
} from "@/models"

import type { MarriageStageType } from "@/models/marriages/MarriageStageType"
import { BasicHttpService } from "./utils"

export class MarriageService extends BasicHttpService {
	constructor() {
		super("/new-api/admin/marriages")
	}

	async search(options: SendableMarriageSearchOptions): Promise<MarriageSearchResults> {
		return await this.returning(MarriageSearchResultsSchema).post(`search`, options)
	}

	async getById(id: Id): Promise<MarriageClaim> {
		return await this.returning(MarriageClaimSchema).get(`${id}`)
	}

	async nullableGetById(id: Id): Promise<MarriageClaim | null> {
		return await this.returning(MarriageClaimSchema.nullable()).get(`${id}/nullable`)
	}

	async getTaxYearBrackets(years: number[]): Promise<TaxYearBracket[]> {
		return await this.returning(TaxYearBracketSchema.array()).get(`year-brackets?years=${years.join("&years=")}`)
	}

	async getSignatureVerificationStatus(id: Id, type: MarriageStageType) {
		return await this.returning(MarriageSignatureVerificationSchema).get(`${id}/verify-signature/${type}`)
	}

	async updateClaim(claim: MarriageClaim): Promise<MarriageClaim> {
		return await this.returning(MarriageClaimSchema).put("", claim)
	}

	async fillPdfWithClaim(claim: MarriageClaim) {
		return await this.returningResponse().post("fill-pdf", claim)
	}

	async getExports(marriageId: Id): Promise<MarriageClaimExport[]> {
		return await this.returning(MarriageClaimExport.array()).get(`${marriageId}/exports`)
	}

	// async updateEligibility(): Promise<MarriageClaim> {
	// 	return await this.returning(MarriageClaimSchema).get(`updateEligibility`)
	// }

	async exportResults(options: SendableMarriageExportSearchOptions) {
		return await this.returningResponse().post(`export`, options)
	}
}
